var _a, _b;
import Color from "color";
import { brand2023 } from "./themes/brand2023";
import { classic } from "./themes/classic";
import { brandAtInnovate } from "./themes/brandAtInnovate";
export var Themes;
(function (Themes) {
    Themes["brand2023"] = "brand2023";
    Themes["classic"] = "classic";
    Themes["brandAtInnovate"] = "brandAtInnovate";
})(Themes || (Themes = {}));
;
export var ThemeNames = (_a = {},
    _a[Themes.brandAtInnovate] = "Brand @ Innovate",
    _a[Themes.brand2023] = "Brand 2023",
    _a[Themes.classic] = "Classic",
    _a);
export var ThemeDefinitions = (_b = {},
    _b[Themes.brandAtInnovate] = brandAtInnovate,
    _b[Themes.brand2023] = brand2023,
    _b[Themes.classic] = classic,
    _b);
export function createColors(primary, secondary, background, error) {
    var primaryColor = Color(primary);
    var secondaryColor = Color(secondary);
    var backgroundColor = Color(background);
    var errorColor = Color(error);
    return {
        primary: {
            main: primary,
            darker: primaryColor.darken(0.5).toString(),
            lighter: primaryColor.lighten(0.5).toString(),
        },
        secondary: {
            main: secondary,
            darker: secondaryColor.darken(0.5).toString(),
            lighter: secondaryColor.lighten(0.5).toString()
        },
        background: {
            main: background,
            darker: backgroundColor.darken(0.5).toString(),
            lighter: backgroundColor.fade(0.5).toString()
        },
        error: {
            main: error,
            darker: errorColor.darken(0.5).toString(),
            lighter: errorColor.lighten(0.5).toString()
        },
    };
}
//Copied from https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/styles/createBreakpoints.js
// and modified for typescript
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"];
// Keep in mind that @media is inclusive by the CSS specification.
export function createBreakpoints(breakpoints) {
    var 
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm[.
    _a = breakpoints.values, 
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm[.
    values = _a === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
        xxl: 2000,
        xxxl: 3000,
    } : _a, _b = breakpoints.unit, unit = _b === void 0 ? "px" : _b, _c = breakpoints.step, step = _c === void 0 ? 5 : _c;
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = keys.indexOf(key) + 1;
        var upperbound = values[keys[endIndex]];
        if (endIndex === keys.length) {
            // xl down applies to all sizes
            return up("xs");
        }
        var value = endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = keys.indexOf(end);
        if (endIndex === keys.length - 1) {
            return up(start);
        }
        return ("@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") +
            "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === "number"
                ? values[keys[endIndex + 1]]
                : end) -
                step / 100).concat(unit, ")"));
    }
    function only(key) {
        return between(key, key);
    }
    function width(key) {
        return values[key];
    }
    return {
        keys: keys,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    };
}
//# sourceMappingURL=theme.js.map